import {
    checkDateIsToday,
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoLabel,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {HabitationMonitoringService} from "../../../serverService/habitationMonitoring/HabitationMonitoringService";
import {useEffect, useState} from "react";
import MealsItem from "./mealsItem/MealsItem";

export default function TotalMeals({periodId,refreshFlag}) {

    const service = new HabitationMonitoringService()
    const [loading, setLoading] = useState(false)


    const [dailyMealsData, setDailyMealsData] = useState({
        breakfast: 0,
        lunch: 0,
        dinner: 0
    })

    function getDataFromServer() {
        setLoading(true)
        service.getDailyCommutingReport(periodId)
            .then(response => {
                setDailyMealsData([])
                response.items.map((item, index) => {

                    if (checkDateIsToday(item.date)) {
                        setDailyMealsData({
                            breakfast: item.numberOfExit + item.numberOfResident,
                            lunch: item.numberOfResident,
                            dinner: item.numberOfResident + item.numberOfEntries
                        })
                    }
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setLoading(false)
        })
    }

    useEffect(() => {
        if (typeof periodId !== "undefined" && periodId >= 0) {
            getDataFromServer()
        }
    }, [periodId]);

    useEffect(() => {
        if (typeof refreshFlag !== "undefined" && refreshFlag) {
            getDataFromServer()
        }
    }, [refreshFlag]);


    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoLabel text={"وعده های غذایی امروز"}/>
                <MealsItem
                    loading={loading}
                    breakfast={dailyMealsData.breakfast}
                    lunch={dailyMealsData.lunch}
                    dinner={dailyMealsData.dinner}
                />
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}